import React from "react";
import { Route, Routes } from "react-router-dom";
import LoginPage from "../containers/LoginPage";
import Home from "../containers/Home";
import { useSelector } from "react-redux";
import Cart from "../containers/Cart";

const AppRoutes = () => {
  const loggedInStatus = useSelector(
    (state) => state.bookingValidation.loggedInStatus
  );

  if (window.location.pathname.includes("login.php")) {
    window.location.href = "/guest-portal"; // redirect from old portal to new portal
  } // remove this after 30 days of live of this website.

  return (
    <Routes>
      <Route path="/" element={loggedInStatus ? <Home /> : <LoginPage />} />
      <Route path="/cart" element={<Cart />} />
    </Routes>
  );
};

export default AppRoutes;
